import { Dispatch, SetStateAction, FC, memo, useState, useEffect, ChangeEvent } from 'react'
import { Select, Skeleton } from '@chakra-ui/react'

import { Place } from 'Geo/types'
import { FilterGroupHeader, FormItem } from 'components'

export type FilterGroupByPlacesProps = {
  title: string
  description: string
  values: any
  setValues: Dispatch<SetStateAction<any>>
  readPlaces: () => Promise<any>
}

const FilterGroupByPlaces: FC<FilterGroupByPlacesProps> = ({ title, description, readPlaces, values, setValues }) => {
  const [loadingPlaces, setLoadingPlaces] = useState(true)
  const [places, setPlaces] = useState<Place[]>([])

  function onChangeSelect(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target
    setValues({ ...values, place_id: value })
  }

  async function loadPlaces() {
    setLoadingPlaces(true)
    const response = await readPlaces()
    if (response?.header?.success) {
      const placesFromAPI = response.body.place.elements
      setPlaces(placesFromAPI)
    }
    setLoadingPlaces(false)
  }

  useEffect(() => {
    loadPlaces()
  }, [])

  return (
    <FilterGroupHeader
      title={title}
      description={description}
      content={
        <FormItem label="Locais disponíveis">
          <Skeleton isLoaded={!loadingPlaces}>
            <Select value={values.place_name} onChange={onChangeSelect}>
              <option value="">Todos</option>
              {places.map((place) => (
                <option key={place.id} value={place.id}>
                  {place.name}
                </option>
              ))}
            </Select>
          </Skeleton>
        </FormItem>
      }
    />
  )
}

export default memo(FilterGroupByPlaces)
